module.exports = __webpack_public_path__ + "img/png_jihua_down.6460309c.png";